import apiClient from "@/services/axios";

export const fetchPendingSchedules = (params) =>
  apiClient.get("/compV3/decaissement/payment-entry/pending-schedules", { params });

export const executeGroupedPayment = (payload) =>
  apiClient.post("/compV3/decaissement/payment-entry/pay", { data: payload });

export const fetchPendingPayments = (params) =>
  apiClient.get("/compV3/decaissement/reconciliation/pending", { params });

export const fetchReconciliationPendingCreators = (params) =>
  apiClient.get("/compV3/decaissement/reconciliation/pending/creators", { params });

export const validatePayment = (id) =>
  apiClient.post(`/compV3/decaissement/reconciliation/${id}/validate`);

export const rejectPayment = (id, rejectionReason) =>
  apiClient.post(`/compV3/decaissement/reconciliation/${id}/reject`, {
    data: { rejectionReason },
  });

export const fetchCreditNotes = (params) =>
  apiClient.get("/compV3/decaissement/avoir/supplier", { params });

/** Depense ids that already have a non-cancelled supplier credit note (invoice picker). */
export const fetchOccupiedDepensesForAvoir = () =>
  apiClient.get("/compV3/decaissement/avoir/supplier/occupied-depenses");

export const fetchCreditNoteById = (id) =>
  apiClient.get(`/compV3/decaissement/avoir/supplier/${id}`);

export const createCreditNote = (payload) =>
  apiClient.post("/compV3/decaissement/avoir/supplier", { data: payload });

export const receiveCreditNote = (id, payload) =>
  apiClient.post(`/compV3/decaissement/avoir/supplier/${id}/receive`, {
    data: payload,
  });

export const fetchPaymentHistory = (params) =>
  apiClient.get("/compV3/decaissement/payments", { params });

export const fetchPaymentDetail = (id) =>
  apiClient.get(`/compV3/decaissement/payments/${id}`);

export const fetchDebts = (params) =>
  apiClient.get("/compV3/decaissement/debts", { params });

export const createDebt = (payload) =>
  apiClient.post("/compV3/decaissement/debts", { data: payload });

export const fetchDebtDetail = (id) =>
  apiClient.get(`/compV3/decaissement/debts/${id}`);
